import $ from 'jquery';
(function(){
  'use strict';

  $(window).ready(function(){
    // Initialise the accordions on the page
    $('.js-tabbed-content').tabify({
      'selector': '.js-tabbed-content',
      'removeContentLabel': true
    });
  });
}());

/**
 * Accessible Tab area
 * Tab navigation using Click, Tab or arrow keys.
 * Tab deep-linking is supported. Apply the ID to the tab container and then append the same ID to the page URL in the format: '#your-id'.
 *
 * Expected mark-up:
 * <div class="tab">
  <h1-6/span/button>Tab label</h1-6/span/button>
  <elem>This is the tab content to show/hide</elem>
 * </div>
 *
 * Basic usage:
 * $('.tab').tabify();
 *
 * Options:
 * 'removeContentLabel' Boolean. Default: false. Whether or not to remove the element in the tab markup that is used as the tab's label.
 *
 * @author jchalmers@squiz.net
 */
(function ( $ ) {

  $.fn.tabify = function( options ) {

    // Options
    var settings = $.extend({
      'removeContentLabel': false,
      'selector': ''
    }, options );

    var $this = {},
      sTabSelector = 'li[role="tab"]',
      sNamespace = 'tab-area',
      $currentTab = {},
      aTabSelectors = [],
      iCurrentTabIndex = 0,
      iNextTabIndex = 0,
      sTabSelector = '',
      sTabLabelSelector = '';

    $this = $( settings.selector );
    sTabSelector = settings.selector.split('.')[1];
    sTabLabelSelector = '.' + sNamespace + '__tab-label';

    createTabMarkup();

    /**
     * Tab buttons.
     */

    // Mouse click
    $(sTabLabelSelector).on( 'click', updateTabs );

    // Check for deep links
    tabDeepLink();

    // UP, LEFT, DOWN and RIGHT arrow keys
    $(sTabLabelSelector).keydown(function(ev) {

      if ( (ev.which === 38) || (ev.which === 37) || (ev.which === 40) || (ev.which === 39) ) {

        // Set the correct context
        $this = $(this).parent().parent();

        // Collect all the tab buttons into an Array
        aTabSelectors = $this.find(sTabLabelSelector).siblings();

        // Get the index of the current tab.
        iCurrentTabIndex = $(this).index();

        if ( (ev.which === 40) || (ev.which === 39) ) {

          // Key DOWN or RIGHT
          // Calculate the next tab

          if ( iCurrentTabIndex + 1 === aTabSelectors.length ) {

            iNextTabIndex = 0;
          } else {

            iNextTabIndex = iCurrentTabIndex + 1;
          }

        } else {

          // Key UP or LEFT
          // Calculate the previous tab

          if ( iCurrentTabIndex - 1 < 0 ) {

            iNextTabIndex = aTabSelectors.length - 1;
          } else {

            iNextTabIndex = iCurrentTabIndex - 1;
          }
        }

        // Focus the correct tab button.
        $(aTabSelectors[ iNextTabIndex ]).focus();

        // Update the tabs and labels.
        updateTabs(null, $(aTabSelectors[ iNextTabIndex ]));
      }
    });

    /*
     * Wraps headers and content within the tab and adds appropriate classes.
     */
    function createTabMarkup() {

      var group = {},
        s_TabIDNumber = '',
        s_AllTabLabelMarkup = '',
        s_PanelARIAHidden = "false",
        s_LabelARIAExpanded = "true",
        s_LabelTabIndex = "0";

      // Group adjacent tabs.
      for ( var i = 0, len = $this.length; i < len; i++ ) {

        group =
          $this
            .eq(i)
            .add(
              $this
                .eq(i)
                .nextUntil( ':not(.' + sTabSelector + ')' )
              );

        // Wrap all adjacent tabs in a container (for easier styling).
        group.wrapAll( '<div class="' + sNamespace + '__container"></div>' );

        i = i + group.length - 1;
      }

      // Iterate through each tab group.
      $('.' + sNamespace + '__container').each(function() {

        s_AllTabLabelMarkup = '<ul class="' + sNamespace + '__menu-list" role="tablist">';
        s_PanelARIAHidden = "false";
        s_LabelARIAExpanded = "true";
        s_LabelTabIndex = "0";

        $(this).children().each(function() {

          // Generate a unique tab ID, if one has not already been included in the markup.
          s_TabIDNumber = $(this).attr('id') || getRandomInt().toString();

          // Create a tab label from the first <h1-6> or <span> child tag in the provided tab markup.
          s_AllTabLabelMarkup += '<li id="tab-' + s_TabIDNumber + '" class="' + sNamespace + '__tab-label" role="tab" aria-controls="panel-' + s_TabIDNumber + '" aria-expanded="' + s_LabelARIAExpanded + '" aria-selected="false" tabindex="' + s_LabelTabIndex + '">' + $(this).children('h1, h2, h3, h4, h5, h6, span, button').eq(0).html() + '</li>';

          // Update content label and set the content tabbing target.
          if ( settings.removeContentLabel ) {

            // Remove the content label.
            $(this).children('h1, h2, h3, h4, h5, h6, span, button').eq(0).remove();

            // Set the first child in the tab content as a tabbing target.
            $(this).children().first().attr('tabindex', '0');
          } else {

            // Add a class to the content label.
            $(this).children('h1, h2, h3, h4, h5, h6, span, button').eq(0).addClass(sNamespace + '__content-title');

            // Set the second child in the tab content as a tabbing target.
            $(this).children().first().next().attr('tabindex', '0');
          }

          // Add the appropriate attributes and classes to the provided tab markup.
          $(this)
            .addClass( sNamespace + '__content' )
            .attr({
              'id': ( 'panel-' + s_TabIDNumber ),
              'aria-labelledby': ( 'tab-' + s_TabIDNumber ),
              'role': 'tabpanel',
              'aria-hidden': s_PanelARIAHidden
            });

          s_PanelARIAHidden = "true";
          s_LabelARIAExpanded = "false";
          s_LabelTabIndex = "-1";
        });

        s_AllTabLabelMarkup += '</ul>';

        $(this).prepend(s_AllTabLabelMarkup);
      });
    }

    /**
     * Updates a tab area to display tab content.
     */
    function updateTabs(evt, tabLabel) {

      // Set the correct context depending on tab click or keyboard input.
      if ( tabLabel ) {

        $this = tabLabel.parent().parent();
        $currentTab = tabLabel;
      } else {

        $this = $(this).parent().parent();
        $currentTab = $(this);
      }

      // Update the tab labels
      $this.find(sTabLabelSelector).attr({
        'aria-selected': 'false',
        'aria-expanded': 'false',
        'tabindex': '-1'
      });

      $currentTab.attr({
        'aria-selected': 'true',
        'aria-expanded': 'true',
        'tabindex': '0'
      });

      // Update the tab content
      $this.children('div[role="tabpanel"]').attr( 'aria-hidden', 'true' );
      $( '#' + $currentTab.attr( 'aria-controls' ) ).attr( 'aria-hidden', 'false' );
    }

    /**
     * Trigger any of the tab deep links.
     */
    function tabDeepLink() {

      var sTabID = document.URL.replace(/^.*?(#|$)/,'');

      $(sTabLabelSelector).each(function() {

        if ( $(this).attr( 'id' ) === 'tab-' + sTabID ) {

          $(this).trigger( 'click' );
        }
      });
    }

    /**
     * Utility function:
     * Generate a random integer from a range
     *
     * @param {Integer} min The minimum value (included)
     * @param {Integer} max The maximum value (Excluded)
     * @returns A Random Integer
     */
    function getRandomInt(min, max) {
      min = 1;
      max = 900000;
      return Math.floor(Math.random() * (max - min)) + min;
    }

    return this;
  };

}( $ ));